import React from 'react';

interface DescriptionProps {
  description: string | null;
}

export default function MoodBoardDescription({ description }: DescriptionProps) {
  return (
    <div className="max-w-[475px] mb-[30px] flex flex-col text-center mx-auto">
      {description && (
        <p className="font-nhg font-normal text-[16px] leading-[140%]">{description}</p>
      )}
    </div>
  );
}
